import { useMutation, MutationHookOptions } from '@companyon/graphql';
import { LINK_CARD_MUTATION } from '../../schema/mutations/linkCard';

export function useLinkCardMutation(options?: MutationHookOptions) {
  return useMutation(LINK_CARD_MUTATION, options);
}
